import { render, staticRenderFns } from "./SentimentHot2.vue?vue&type=template&id=5cf8fcbe&scoped=true"
import script from "./SentimentHot2.vue?vue&type=script&lang=js"
export * from "./SentimentHot2.vue?vue&type=script&lang=js"
import style0 from "./SentimentHot2.vue?vue&type=style&index=0&id=5cf8fcbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf8fcbe",
  null
  
)

export default component.exports